// antd ships its own locale bundles. Isolated in its own module so the antd
// locale data is only pulled in by the component that actually renders an
// antd <ConfigProvider> (currently only pages/BatchMortality.js).
import enUS from 'antd/locale/en_US';
import msMY from 'antd/locale/ms_MY';
import { normalizeLng } from './locale';

const LOCALES = { en: enUS, ms: msMY };

export const getAntdLocale = (lng) => LOCALES[normalizeLng(lng)] || LOCALES.en;
